import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MenuItem } from 'primeng/api';

import { AppMenuitem } from './app.menuitem';

import { TranslateService } from '../../services/translate.service';
import { SelectAccountComponent } from '../../pages/management/select-account/select-account.component';
import { AjaxService } from '../../services/ajax.service';
import { ConfigService } from '../../services/config.service';
import { ViewScopeService } from '../../services/view-scope.service';

import { DYNAMIC_MENU } from '../../services/account-api.constants';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule, SelectAccountComponent],
    templateUrl: './app.menu.html',
})
export class AppMenu implements OnInit 
{
    model: MenuItem[] = [];
    loading = false;

    constructor(
        public translateServ: TranslateService,
        private ajax: AjaxService,
        private configService: ConfigService,
        private viewScopeService: ViewScopeService
    ) {}

    ngOnInit() {
        this.loadMenu();
    }

    loadMenu() 
    {
        const apiKey = this.ajax.getBaseOfApi() + '/' + DYNAMIC_MENU + '/' + this.viewScopeService.getCurrentOpertaingUserId();
        
        this.loading = true;
        (this.ajax.getData(apiKey) as any).subscribe(
            (menuData: any[]) => {
                this.model = this.transformMenu(menuData);
                this.loading = false;
            },
            (err: any) => {
                this.loading = false;
                console.error("[AppMenu] Error at loading menu:", err);
                if (err && err.message) {
                    console.error("[AppMenu] Error message:", err.message);
                }
                if (err && err.error) {
                    console.error("[AppMenu] Backend error:", err.error);
                }
            }
        );
    }

    /**
     * Transform backend menu data to PrimeNG MenuItem[]
     * @param menuData Raw menu data from backend
     */
    transformMenu(menuData: any[]): MenuItem[] {
        if (!Array.isArray(menuData)) return [];
        // Group by MenuSectionName
        const groups: { [section: string]: any[] } = {};
        menuData.forEach((item: any) => {
            if (!groups[item.MenuSectionName]) {
                groups[item.MenuSectionName] = [];
            }
            groups[item.MenuSectionName].push(item);
        });

        // Build MenuItem[]
        const menu = Object.keys(groups).map(section => ({
            label: section,
            items: groups[section]
                .sort((a, b) => a.RowOrder - b.RowOrder)
                .map((item: any) => {
                    let routerLink: string[] | undefined = undefined;
                    if (item.RoutingPath) {
                        if (Array.isArray(item.RoutingPath)) {
                            routerLink = item.RoutingPath;
                        } else if (typeof item.RoutingPath === 'string') {
                            // Safely extract route from string like ['...']
                            const match = item.RoutingPath.match(/\['([^']+)'\]/);
                            if (match && match[1]) {
                                routerLink = [match[1]];
                            } else {
                                routerLink = undefined;
                            }
                        }
                    }
                    return {
                        label: item.PageTitle,
                        icon: item.IconImageURL,
                        routerLink,
                        visible: true
                    };
                })
        }));
        // console.log('[AppMenu] Dynamic menu structure:', JSON.stringify(menu, null, 2)); // Print the structure for debugging
        return menu;
    }
}
